import { render, staticRenderFns } from "./CreateCategoriesModal.vue?vue&type=template&id=35152bb7&scoped=true&"
import script from "./CreateCategoriesModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./CreateCategoriesModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CreateCategoriesModal.vue?vue&type=style&index=0&id=35152bb7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35152bb7",
  null
  
)

export default component.exports